import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

const LicenseCertificate = ({ height = 140, width = 140, fill = "#F9FBFB", ...props }) => {
  const { adventure_mode } = useSelector((store) => store.user)
  const themeColor = adventure_mode === "sportsman" ? "var(--color-sportsman-brand)" : "var(--color-sportswoman-brand)"

  return (
    <svg width={width} height={height} viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={width} height={height} rx="70" fill={fill} />
      <path d="M99.9208 106.25H42.791V33.3481H98.3795L99.9208 106.25Z" fill={themeColor} />
      <path d="M41.25 32.5H98.3797V105.402H41.25V32.5Z" fill="white" />
      <path d="M49.3164 39.4578H90.3142V39.7734H49.3164V39.4578Z" fill={themeColor} />
      <path d="M49.3164 49.3991H90.3142V49.7147H49.3164V49.3991Z" fill={themeColor} />
      <path d="M49.3164 59.3403H90.3142V59.6559H49.3164V59.3403Z" fill={themeColor} />
      <path d="M49.3164 69.2815H90.3142V69.5971H49.3164V69.2815Z" fill={themeColor} />
      <path d="M49.3164 79.2227H90.3142V79.5383H49.3164V79.2227Z" fill={themeColor} />
      <path d="M49.3164 89.1639H90.3142V89.4796H49.3164V89.1639Z" fill={themeColor} />
      <path
        d="M45.7279 37.4882C46.6002 37.4882 47.3073 36.7811 47.3073 35.9088C47.3073 35.0365 46.6002 34.3293 45.7279 34.3293C44.8556 34.3293 44.1484 35.0365 44.1484 35.9088C44.1484 36.7811 44.8556 37.4882 45.7279 37.4882Z"
        fill={themeColor}
      />
      <path
        d="M94.4857 37.4881C95.358 37.4881 96.0651 36.781 96.0651 35.9087C96.0651 35.0364 95.358 34.3292 94.4857 34.3292C93.6134 34.3292 92.9062 35.0364 92.9062 35.9087C92.9062 36.781 93.6134 37.4881 94.4857 37.4881Z"
        fill={themeColor}
      />
    </svg>
  )
}

LicenseCertificate.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}

export default LicenseCertificate
